<script setup>
const emit = defineEmits(['back']);
const handleGoBack = () => {
  emit('back');
};
</script>

<template>
  <div class="back-button" @click="handleGoBack"></div>
</template>

<style scoped lang="postcss">
.back-button {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--accent-color);
  cursor: pointer;
  display: block;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 10px;
    height: 17px;
    background-image: url('~/assets/images/chevron_right.svg');
    transform: translateX(-1px) rotate(180deg);
  }
}
</style>
